module.exports = __webpack_public_path__ + "img/briefcase-02.0235f078.svg";